module.exports = __webpack_public_path__ + "img/logo-m2n.2aae3e6a.svg";